import { useEffect } from 'react';

export const useMatchMedia = (query, callback) =>
    useEffect(() => {
        const handler = () => {
            const match = window.matchMedia(query);
            callback(match);
        };
        handler();
        window.addEventListener('resize', handler);
        return () => {
            window.removeEventListener('resize', handler);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
